import React from "react";
import { Link } from "@quintype/components";
import { get } from "lodash";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../../constants";
import { getStoryHeadline, getStoryLabel, isExternalStory } from "../../../utils/story";
import { PublishAndReadTime } from "../../../atoms/PublishAndReadTime";
import { HeroImage } from "../../../atoms/HeroImage";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";
import SubHeadline from "../../../atoms/SubHeadline";

import "../top-component-home-page.m.css";

const StoryTextContent = ({ story, type, showSubHeadline = false, show_timestamp, show_read_time, sectionSlug }) => {
  const { subheadline } = story;
  const label = getStoryLabel(story);
  const headline = getStoryHeadline(story);

  return (
    <div styleName={`${type}-story-box`}>
      {label && <Label story={story} />}

      {headline && <Headline styleName={`${type}-headline`} headline={headline} sectionSlug={sectionSlug} />}
      {showSubHeadline && subheadline && (
        <SubHeadline styleName="main-subheadline" subHeadline={subheadline} sectionSlug={sectionSlug} />
      )}
      <PublishAndReadTime showReadTime={show_read_time} showTimestamp={show_timestamp} story={story} />
    </div>
  );
};

export const StoryComponent = ({
  story,
  type,
  showImage = false,
  showSubHeadline = false,
  show_timestamp,
  show_read_time,
  showFallbackImage = true,
  sectionSlug,
}) => {
  const sponsor = get(story, ["metadata", "sponsored-by"], null);
  const isPartneredContent = story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor !== null;
  if (isPartneredContent && type !== "primary") {
    showImage = true;
  }
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  const slug =
    get(story, ["hero-image-s3-key"]) ||
    get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]);
  const showHeroImage = showImage && (showFallbackImage || slug);

  return (
    <div styleName="link-a">
      <Link href={href} target={target}>
        {showHeroImage ? (
          <div styleName={`${type}-story-container`}>
            <StoryTextContent
              story={story}
              type={type}
              showSubHeadline={showSubHeadline}
              show_timestamp={show_timestamp}
              show_read_time={show_read_time}
              sectionSlug={sectionSlug}
            />
            {type === "tertiary" ? (
              story?.["hero-image-s3-key"] ? (
                <div styleName={`${type}-story-image-container`}>
                  <HeroImage
                    story={story}
                    widths={[135]}
                    aspectRatio={[[4, 3]]}
                    headline={getStoryHeadline(story)}
                    iconSizes={{ width: 24, height: 24 }}
                    showFallbackImage={showFallbackImage}
                  />
                </div>
              ) : (
                ""
              )
            ) : (
              <div styleName={`${type}-story-image-container`}>
                <HeroImage
                  story={story}
                  widths={[135]}
                  aspectRatio={[[4, 3]]}
                  headline={getStoryHeadline(story)}
                  iconSizes={{ width: 24, height: 24 }}
                  showFallbackImage={showFallbackImage}
                />
              </div>
            )}
          </div>
        ) : (
          <StoryTextContent
            story={story}
            type={type}
            showSubHeadline={showSubHeadline}
            show_timestamp={show_timestamp}
            show_read_time={show_read_time}
            sectionSlug={sectionSlug}
          />
        )}
      </Link>
    </div>
  );
};
